export default "__VITE_ASSET__DFOv1iIW__"